import { httpsCallable } from "firebase/functions";
import { functions } from "shared/api/firebase";

export type DeleteAdminParams = {
  id: string;
};

const deleteAdmin = async (params: DeleteAdminParams): Promise<void> => {
  const fn = httpsCallable<DeleteAdminParams, void>(functions, "deleteAdmin");
  await fn(params);
};

export default deleteAdmin;
